<app-kpi-widget
  [title]="title"
  [icon]="'ph-duotone ph-clock'"
  [isLoading]="isLoading"
  [totalValue]="value"
  [percentageDifference]="percentageDifference"
  [hasError]="hasError"
  [errorMessage]="errorMessage"
  [valueFormatter]="formatValue.bind(this)"
  [isImageIcon]="false"
  [dropdownEnabled]="false"
  [hasFooter]="false"
  [hasValueOnly]="true"
  [hasDifference]="false"
  [hasCost]="false"
  [hasCostDifference]="false"
  [isUptrendPositive]="false"></app-kpi-widget>
